export const MaxCountOfChars = 3000;
